import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Panel, Modal, Button, Glyphicon } from 'react-bootstrap';
import I18n from 'i18n-react';

import './DynamicPanel.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
};

class DynamicPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      openCollapse: false
    };
  }

  componentDidMount(){
    if(this.props.openCollapse){
      this.setState({
        openCollapse: this.props.openCollapse
      });
    }
  }

  showModal = () => {
    this.setState({
      showModal: true
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false
    });
  };

  onToggle = () => {
    this.setState({
      openCollapse: !this.state.openCollapse
    });
  };

  render() {
    return (
      <Row className="DynamicPanel">
        <Col className="DynamicPanel__modalType" xs={12} smHidden mdHidden lgHidden>
          <Button
            id={`btnOpenModal${this.props.id}`}
            onClick={this.showModal}
            bsClass="DynamicPanel__btnModal">
            {I18n.translate(this.props.title)}
          </Button>
          <Modal
            id={`mdl${this.props.id}`}
            className="DynamicPanel__modal"
            show={this.state.showModal}
            onHide={this.closeModal}
            bsSize="lg">
            <Modal.Header closeButton className="DynamicPanel__hdrModal">
              <Modal.Title bsClass="DynamicPanel__ttlModal">
                {I18n.translate(this.props.title)}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.props.children}</Modal.Body>
          </Modal>
        </Col>
        <Col className="DynamicPanel__panelType" xsHidden sm={12}>
          <Panel
            id={`clp${this.props.id}`}
            className="DynamicPanel__collapsePanel"
            onToggle={this.onToggle}
            expanded={this.state.openCollapse}>
            <Panel.Heading className="DynamicPanel__hdrCollapsePanel">
              <Panel.Toggle
                id={`tglCollapsePanel${this.props.id}`}
                componentClass="div"
                className="DynamicPanel__toggleCollapsePanel">
                <Panel.Title className="DynamicPanel__ttlCollapsePanel">
                  <Glyphicon
                    glyph={this.state.openCollapse ? 'chevron-up' : 'chevron-down'}
                    className="DynamicPanel__icnCollapsePanel"
                  />
                  {I18n.translate(this.props.title)}
                </Panel.Title>
              </Panel.Toggle>
            </Panel.Heading>
            <Panel.Collapse>
              <Panel.Body id={`panelBody${this.props.id}`}>{this.props.children}</Panel.Body>
            </Panel.Collapse>
          </Panel>
        </Col>
      </Row>
    );
  }
}

DynamicPanel.propTypes = propTypes;

export default DynamicPanel;



// WEBPACK FOOTER //
// ./src/components/bookingResume/dynamicPanel/DynamicPanel.jsx